$(document).ready(function() {
  $('#datatable-report-stocks').dataTable( {
    "lengthMenu": [[50, 100, -1], [50, 100, "All"]]
  } );
} );
